import i18next from "i18next";
import { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import Router from "./Routes/Router";
import "./App.css";

const App: React.FC = () => {
  const [_forceRenderKey, _setForceRenderKey] = useState(0);

  // Render all components on language change by changing key (forcing components render) :
  i18next.on("languageChanged", () => {
    _setForceRenderKey(Math.floor(Math.random() * 100));
    document.documentElement.dir = i18next.dir(i18next.language);
  });

  useEffect(() => {
    document.documentElement.dir = i18next.dir(i18next.language);
  }, []);

  return (
    <div key={_forceRenderKey}>
      <BrowserRouter>
        <Router />
      </BrowserRouter>
    </div>
  );
};

export default App;
